import {
  AnsokanFormStepOneModel,
  FolkbokforingsAdress,
  LegAnsokan,
  LegAnsokanPayload,
  AnsokanFormTexts,
  EducationLocation,
} from '../../models/ansokan.model';
import { FormFieldProps, ResourceItem } from 'sos-common/js/commonTypes';
import {
  TextInputProps,
  SelectBoxProps,
  IFileUploadProps,
  CheckBoxProps,
  RadioButtonGroup,
  RadioButtonGroupProps,
} from 'sos-common/js';
import { FieldMap } from './FieldMap';
import { FieldMapEuEes } from './FieldMapEuEes';

export interface ILegAnsokanFormProps {
  model: AnsokanFormStepOneModel;
  folkbokforing: FolkbokforingsAdress;
  ansokan: LegAnsokan;
  stepTwoPageLink: string;
  formTexts: AnsokanFormTexts;
  deleteLink: string;
  myPage: string;
  translations: ResourceItem[];
  modalTranslations: ResourceItem[];
  educationLocation: EducationLocation;
  granskningsProcess: boolean;
}

export interface ILegAnsokanEuEESFormProps extends ILegAnsokanFormProps {
  typeOfEuEESAnsokan: EuEesAnsokanType;
}

export interface IlegAnsokanEuEesState {
  fieldMapEu: FieldMapEuEes;
  payload: LegAnsokanPayload;
  showSpinner: boolean;
  isLoading: boolean;
  isSaveErrorModalOpen: boolean;
  certInOtherCountry?: boolean;
  showAddressInfo: boolean;
}
export interface ILegAnsokanFormState {
  fieldMap: FieldMap;
  payload: LegAnsokanPayload;
  showSpinner: boolean;
  isLoading: boolean;
  isSaveErrorModalOpen: boolean;
  showAddressInfo: boolean;
  LegitimationOtherCountry?: boolean;
  AssessmentAllowContact?: boolean;
}

export type LegAnsokanFieldMap = Map<LegAnsokanFormFieldName | string, LegAnsokanField>;
export type LegAnsokanField = FormFieldProps<any> | TextInputProps | SelectBoxProps | IFileUploadProps | CheckBoxProps;

export enum LegAnsokanFormFieldName {
  Email = 'Epost',
  ConfirmEmail = 'BekraftaEpost',
  Telefonnummer = 'Telefonnummer',
  SchoolSelect = 'LarosateId',
  ExaminationDate = 'ExamensBevisDatum',
  PrimaryFiles = 'PrimaryFiles', //NOTE: If changed, server FileTag enum name has to change too.
  TermsAndConditions = 'AccepteratVillkor',
  SecondaryFiles = 'SecondaryFiles', //NOTE: If changed, server  FileTag enum name has to change too.
  CheckboxValue = 'CheckboxValue',
  UtbildningsLand = 'UtbildningsLandId',
  EducationTitle = 'Utbildningstitel',
  EducationLength = 'UtbildningsLangd',
  ExaminationYear = 'ExamensAr',
  LegitimationOtherCountry = 'LegitimationFranAnnatLand',
  LegitimationAndraLanderId = 'LegitimationAndraLanderId',
  DateOfCertificate = 'DatumForIntygOmYrkesbehorighet',
  DateOfLegitimationCertificate = 'DatumForLegitimeradOmYrkesbehorighet',
  HasCertInOtherCountry = 'BehorighetsbevisFranAnnatLand',
  OtherCertCountries = 'LanderForBehorighetsBevis',
  EducationForm = 'UtbildningsFormId',
  EducationPeriod = 'UtbildningsPeriodId',
  FileUpload1 = 'Fileupload1Files', //NOTE: If changed, server  FileTag enum name has to change too.
  FileUpload2 = 'Fileupload2Files', //NOTE: If changed, server  FileTag enum name has to change too.
  FileUpload3 = 'Fileupload3Files', //NOTE: If changed, server  FileTag enum name has to change too.
  FileUpload4 = 'Fileupload4Files', //NOTE: If changed, server  FileTag enum name has to change too.
  FileUpload5 = 'Fileupload5Files', //NOTE: If changed, server  FileTag enum name has to change too.
  FileUpload6 = 'Fileupload6Files',
  FileUpload7 = 'Fileupload7Files',
  Diarienummer = 'DiarienummerTidigareAnsokan',
  AssessmentEducationAfterHighSchool = 'EftergymnasialUtbildning',
  AssessmentDegree = 'Utbildningstitel',
  AssessmentEducationPlace = 'LarosateNamn',
  AssessmentVocationalYears = 'utbildningslangd',
  AssessmentStartYear = 'UtbildningPaborjad',
  AssessmentGraduationYear = 'Examensar',
  AssessmentEducationCountry = 'UtbildningslandNamn',
  AssessmentWorkedAfterGraduation = 'ArbetatEfterExamen',
  AssessmentAllowContact = 'TillatelseKontaktaSkolaMyndighet',
  AssessmentDenyReason = 'MotiveringEjKontaktaSkolaMyndighet',
  PaidAssessmentFeeEarlier = 'BetaltVidGranskning',
  PaymentDate = 'DatumForTidigareBetalning',
  CompletedSupplementaryEducation = 'GjortKompletterandeUtbildning',
}

export enum Yrke {
  Apotekare = '100001',
  Arbetsterapeut = '100002',
  Audionom = '100003',
  Barnmorska = '100004',
  BiomedicinskAnalytiker = '100005',
  Dietist = '100006',
  Fysioterapeut = '100025',
  HalsoOchSjukvardskurator = '100026',
  Kiropraktor = '100007',
  Lakare = '100009',
  Logoped = '100008',
  Naprapat = '100010',
  Optiker = '100011',
  Ortopedingenjor = '100012',
  Psykolog = '100013',
  Psykoterapeut = '100014',
  Receptarie = '100015',
  Rontgensjukskoterska = '100016',
  Sjukhusfysiker = '100018',
  Sjukskoterska = '100019',
  Tandhygienist = '100020',
  Tandlakare = '100021',
  Underskoterska = '100001',
}
export enum EuEesAnsokanType {
  Sweden = 0,
  EuEES = 1,
}
export const YRKE_LIST = [
  Yrke.Apotekare,
  Yrke.Arbetsterapeut,
  Yrke.Audionom,
  Yrke.Barnmorska,
  Yrke.BiomedicinskAnalytiker,
  Yrke.Dietist,
  Yrke.Fysioterapeut,
  Yrke.HalsoOchSjukvardskurator,
  Yrke.Kiropraktor,
  Yrke.Logoped,
  Yrke.Lakare,
  Yrke.Naprapat,
  Yrke.Optiker,
  Yrke.Ortopedingenjor,
  Yrke.Psykolog,
  Yrke.Psykoterapeut,
  Yrke.Receptarie,
  Yrke.Rontgensjukskoterska,
  Yrke.Sjukhusfysiker,
  Yrke.Sjukskoterska,
  Yrke.Tandhygienist,
  Yrke.Tandlakare,
  Yrke.Underskoterska,
];
